export const proposalStatusesSummary = state => state.stats.proposalStatusesSummary
export const proposalsLeadSources = state => state.stats.proposalsLeadSources